export default {
  handle_input(index, event) {
    const value = (event.target.value || '').replace(/\D/g, '');

    if (value.length > 1) {
      this.apply_otp_value(value, parseInt(index, 10), event.target);
      return;
    }

    this.otp[parseInt(index, 10)] = value;

    if (value && index < this.otp.length - 1) {
      const inputs = event.target.closest('.otp-inputs').querySelectorAll('input');
      if (inputs[index + 1]) {
        inputs[index + 1].focus();
      }
    }

    if (this.get_otp_code().length === 6) {
      this.handle_verify_otp();
    }
  },

  apply_otp_value(raw_value, start_index = 0, active_input = null) {
    const digits = String(raw_value || '').replace(/\D/g, '').slice(0, this.otp.length);

    if (!digits) {
      return;
    }

    const next_otp = [...this.otp];

    digits.split('').forEach((digit, offset) => {
      const target_index = start_index + offset;
      if (target_index < next_otp.length) {
        next_otp[parseInt(target_index, 10)] = digit;
      }
    });

    this.otp = next_otp;

    this.$nextTick(() => {
      const inputs = active_input?.closest('.otp-inputs')?.querySelectorAll('input') || null;

      if (!inputs?.length) {
        return;
      }

      const filled_index = Math.min(start_index + digits.length - 1, this.otp.length - 1);
      const next_empty_index = this.otp.findIndex(digit => !digit);
      const focus_index = next_empty_index === -1 ? filled_index : next_empty_index;

      if (inputs[parseInt(focus_index, 10)]) {
        inputs[parseInt(focus_index, 10)].focus();
      }

      if (this.get_otp_code().length === this.otp.length) {
        this.handle_verify_otp();
      }
    });
  },

  handle_paste(index, event) {
    const pasted_text = event.clipboardData?.getData('text') || '';
    const digits = pasted_text.replace(/\D/g, '');

    if (!digits) {
      return;
    }

    event.preventDefault();
    this.apply_otp_value(digits, parseInt(index, 10), event.target);
  },

  handle_backspace(index, event) {
    if (!this.otp[parseInt(index, 10)] && index > 0) {
      const inputs = event.target.closest('.otp-inputs').querySelectorAll('input');
      if (inputs[index - 1]) {
        inputs[index - 1].focus();
      }
    }
  },

  get_otp_code() {
    return this.otp.join('').trim();
  }
};
